import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import merge from 'lodash.merge';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { formatter } from './ChartTooltip';
import { PointShape } from './shape';

const container = {
  style: {
    height: '100%',
    width: '100%',
  },
};

const base = {
  chart: {
    animation: false,
    style: {
      fontFamily: 'Mulish, Helvetica Neue, sans-serif',
    },
  },

  colors: ['#9D9DFF', '#FF97BC', '#6FDDDB', '#FFBB61'],

  credits: {
    enabled: false,
  },

  legend: {
    align: 'left',
    margin: 24,
    itemDistance: 16,
    itemHiddenStyle: {
      color: 'var(--text-tertiary)',
    },
    itemHoverStyle: {
      color: 'var(--text-secondary)',
    },
    itemStyle: {
      color: 'var(--text-primary)',
    },
    symbolHeight: 12,
    symbolWidth: 12,
    symbolRadius: 6,
    verticalAlign: 'top',
  },

  plotOptions: {
    series: {
      animation: false,
      marker: {
        symbol: 'circle',
      },
    },
  },

  time: {
    useUTC: false,
  },

  title: {
    text: null,
  },

  tooltip: {
    formatter,
    padding: 12,
    shared: true,
    useHTML: true,
  },

  xAxis: {
    dateTimeLabelFormats: {
      day: '%b %e',
      month: "%b '%y",
    },
    title: {
      margin: 16,
      style: {
        color: 'var(--text-primary)',
        fontWeight: 'var(--semi-bold)',
      },
      text: 'Date',
    },
    type: 'datetime',
  },

  yAxis: {
    title: {
      margin: 12,
      style: {
        color: 'var(--text-primary)',
        fontWeight: 'var(--semi-bold)',
      },
      text: 'Count',
    },
  },
};

export default function Chart({ options: overrides, series }) {
  const options = useMemo(() => {
    const merged = merge(base, overrides);
    return { ...merged, series };
  }, [overrides, series]);

  return (
    <HighchartsReact
      containerProps={container}
      highcharts={Highcharts}
      options={options}
    />
  );
}

Chart.propTypes = {
  // Inherits from Highcharts options
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.object,

  series: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      color: PropTypes.string,
      type: PropTypes.string,
      data: PropTypes.arrayOf(PointShape),
    })
  ),
};
